import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DocumentLink } from '../components/DocumentLink';

export const Route = createFileRoute('/document/$link')({
  component: RouteComponent,
  params: z.object({
    link: z.string(),
  }),
});

function RouteComponent() {
  const { link } = Route.useParams();
  return <DocumentLink link={link} />;
}
